import { BiathlonIcon } from './BiathlonIcon';

/**
 * author: Google
 * id 7E88D677-5560-4DF1-A3D0-FC2814BF6612
 * name biathlon
 * version: 3.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/biathlon.svg
 * tags
 * - Sport 
 * - People / Family 
 */
export const HumanBiathlonIcon = BiathlonIcon;
export default HumanBiathlonIcon